$('.banner_slider_wrap').slick({
  dots: true,
  arrows:false,
  infinite: true,       // fade works best with infinite true
  speed: 1000,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,       // enable autoplay
  autoplaySpeed: 3000,  // optional (3 sec) 
  fade:true
});
// $('.custom_product_inner').slick({
//   dots: true,
//   arrows:false,
//   infinite: true,       // fade works best with infinite true
//   speed: 1000,
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   autoplay: true,       // enable autoplay
//   autoplaySpeed: 3000, 
//   fade:true // optional (3 sec)
// });




function initMobileSliders() {
  $('.slider-section').each(function() {

    let section = $(this);
    let slider = section.find('.third_slider');
    let arrowContainer = section.find('.multicolm_slider_button');

    if ($(window).width() <= 749) {

      if (!slider.hasClass('slick-initialized')) {

        arrowContainer.empty();

        slider.slick({
          dots: false,
          infinite: false,
          speed: 1000,
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: false,
          fade: false,
          arrows: true,
          appendArrows: arrowContainer,
          prevArrow: `
            <button class="slick-prev">
              <svg xmlns="http://www.w3.org/2000/svg" width="40px" height="40px" viewBox="-19.04 0 75.804 75.804">
                <g id="Group_65" data-name="Group 65" transform="translate(-831.568 -384.448)">
                  <path id="Path_57" data-name="Path 57" d="M833.068,460.252a1.5,1.5,0,0,1-1.061-2.561l33.557-33.56a2.53,2.53,0,0,0,0-3.564l-33.557-33.558a1.5,1.5,0,0,1,2.122-2.121l33.556,33.558a5.53,5.53,0,0,1,0,7.807l-33.557,33.56A1.5,1.5,0,0,1,833.068,460.252Z" fill="#133c04eb"/>
                </g>
              </svg>
            </button>
          `,
          nextArrow: `
            <button class="slick-next">
              <svg xmlns="http://www.w3.org/2000/svg" width="40px" height="40px" viewBox="-19.04 0 75.804 75.804">
                <g id="Group_65" data-name="Group 65" transform="translate(-831.568 -384.448)">
                  <path id="Path_57" data-name="Path 57" d="M833.068,460.252a1.5,1.5,0,0,1-1.061-2.561l33.557-33.56a2.53,2.53,0,0,0,0-3.564l-33.557-33.558a1.5,1.5,0,0,1,2.122-2.121l33.556,33.558a5.53,5.53,0,0,1,0,7.807l-33.557,33.56A1.5,1.5,0,0,1,833.068,460.252Z" fill="#133c04eb"/>
                </g>
              </svg>
            </button>
          `,
        });
      } 

    } else {
      if (slider.hasClass('slick-initialized')) {
        slider.slick('unslick');
        arrowContainer.empty();
      }
    }

  });
}

initMobileSliders();
$(window).on('resize', initMobileSliders);




document.addEventListener("DOMContentLoaded", () => {
  const accordions = document.querySelectorAll(".product__accordion details");

  accordions.forEach(details => {
    const summary = details.querySelector("summary");
    const content = details.querySelector(".accordion__content");

    summary.addEventListener("click", (e) => {
      e.preventDefault();

      // Close all other accordions
      accordions.forEach(other => {
        if (other !== details && other.hasAttribute("open")) {
          const otherContent = other.querySelector(".accordion__content");
          otherContent.style.maxHeight = otherContent.scrollHeight + "px";
          requestAnimationFrame(() => {
            otherContent.style.maxHeight = "0px";
          });
          other.removeAttribute("open");
        }
      });

      // Toggle current accordion
      if (details.hasAttribute("open")) {
        // CLOSE
        content.style.maxHeight = content.scrollHeight + "px";
        requestAnimationFrame(() => {
          content.style.maxHeight = "0";
        });
        details.removeAttribute("open");
      } else {
        // OPEN
        details.setAttribute("open", "");
        content.style.maxHeight = content.scrollHeight + "px";
      }
    });
  });
});



$('.custom_thumb_slider').slick({
  vertical: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  verticalSwiping: true,
  infinite: false,
  arrows: true,
  dots: false,

  prevArrow: `
    <button type="button" class="slick-prev custom-arrow">
      <svg class="icon icon-caret" viewBox="0 0 10 6" style="transform: rotate(180deg);">
        <path fill="currentColor" fill-rule="evenodd"
          d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708"
          clip-rule="evenodd"></path>
      </svg>
    </button>`
 ,

  nextArrow:  `
    <button type="button"  class="slick-next custom-arrow">
      <svg class="icon icon-caret" viewBox="0 0 10 6">
        <path fill="currentColor" fill-rule="evenodd"
          d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708"
          clip-rule="evenodd"></path>
      </svg>
    </button>`
});


$(document).ready(function(){

  $('.new_custom_image_call').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    fade: true,
    speed: 1000,          // smooth fade speed
    autoplay: true,
    autoplaySpeed: 3000,  // delay between slides
    arrows: false,
    dots: false,
    pauseOnHover: false,
    pauseOnFocus: false
  });

});
